import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import {
  fetchTopicsForPinnedKnowledgeFulfilled,
  fetchTopicsForPinnedKnowledgeRejected,
} from "domains/pinAddReject/actions";
import type { FetchTopicsForPinnedKnowledge } from "domains/pinAddReject/actionTypes";

export function* fetchTopicsForPinnedKnowledgeSaga(action: FetchTopicsForPinnedKnowledge) {
  const { knowledgeId } = action.meta;

  try {
    const payload: { topic_ids: string[] } = yield apiFetch(`knowledge/${knowledgeId}/pin`, {
      method: "GET",
      ...(action.meta.forceRefresh ? { headers: { "Cache-Control": "no-cache" } } : {}),
    });

    yield put(fetchTopicsForPinnedKnowledgeFulfilled({ knowledgeId }, { topicIds: payload.topic_ids }));
  } catch (error) {
    logger.error(
      "[fetchTopicsForPinnedKnowledgeSaga] Error occurred while fetching topics for pinned knowledge",
      error,
    );
    yield put(fetchTopicsForPinnedKnowledgeRejected({ knowledgeId, logoutOnAuthError: true }));
  }
}
